<template>
    <div class="all-comment">
        <Loading v-if="!loadingDone"/>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多啦~"
            :error.sync="error"
            error-text="请求失败  点击重新加载"
            @load="onCommentLoad"
            :offset=100
            :immediate-check="false"
            v-if="loadingDone"
        >
            <van-cell class="user-comment-item" v-for="(fatherItem,index) in oneLevelCommentList" :key="index" style="padding:0px;">
                <div class="user-avatar">
                    <img :src="fatherItem&&fatherItem.icon" alt="">
                </div>
                <router-link :to="{name:'seccomment',query:{id:fatherItem.article_id,for_id:fatherItem&&fatherItem.id}}">
                    <div class="user-comment-detail" :data-role="fatherItem&&fatherItem.id" @click="getForId">
                        <p class="user-name">{{fatherItem&&fatherItem.user_name}}<span style="float:right;color:#999">{{fatherItem&&fatherItem.created_at}}</span></p>
                        <p class="comment-cont">{{fatherItem&&fatherItem.content}}</p>
                    </div>
                </router-link>
                <ul class="second-level-comment">
                    <li v-for="(childItem,index) in fatherItem.child" :key="index">
                        <router-link :to="{name:'seccomment',query:{id:childItem.article_id,for_id:childItem&&childItem.for_id}}">
                            <div class="user-avatar">
                                <img :src="childItem&&childItem.icon" alt="">
                            </div>
                            <div class="user-comment-detail">
                                <p class="user-name">{{childItem&&childItem.user_name}}<span style="float:right;color:#999">{{childItem&&childItem.created_at}}</span></p>
                                <p class="comment-cont">{{childItem&&childItem.content}}</p>
                            </div>
                        </router-link>
                    </li>
                    <div class="show-all-second-level-comment" v-if="fatherItem.many!==0" :data-role="fatherItem&&fatherItem.id" @click="getMoreTwoLevelComment">查看更多<van-icon name="arrow-down" /></div>
                    <div class="hide-all-second-level-comment" v-if="hideTwoLevelComment&&fatherItem.id==curHideBtnId" :data-role="fatherItem&&fatherItem.id" @click="hideMoreTwoLevelComment">收起<van-icon name="arrow-up" /></div>
                </ul>
            </van-cell>
        </van-list>
        <div :class="{'add-comment-box':true,'add-comment-box-focus':textareaFocus}">
            <textarea placeholder="想说点什么..." v-model="commentContent" @focus="changeCommentBoxHeight" @blur="textBlur" :class="{'textarea-focus':textareaFocus}"/>
            <button @click="addOneLevelComment" :disabled="sendBtnDisabled" :class="{'sending':commentSending,'btn-in-textarea-focus':textareaFocus}"  ref="sendBtn">发表</button>
        </div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import {GetCookie} from '@/assets/api/cookie'
import Loading from '@/components/Loading'
import notifyIcon from '@/assets/img/msgicon.png'
export default{
    name:'AllComment',
    data(){
        return{
            loading: false,                     //控制上划加载状态显示
            finished: false,                    //控制上划加载完成状态显示
            error: false,                       //控制上划加载出错状态显示
            commentContent:'',                  //发送评论的评论内容
            forId:'',                           //二级评论for_id参数
            sendBtnDisabled:false,              //控制评论发送按钮可点击状态 防重复提交
            commentSending:false,               //控制评论发送中按钮颜色
            oneLevelCommentList:[],             //储存一级评论
            oneLevelCommentPageNum:1,           //一级评论请求页码
            haveMoreOneLevelComment:1,         //是否还有更多一级评论
            twoLevelCommentList:[],             //储存二级评论
            haveMoreTwoLevelComment:'',         //是否还有更多二级评论
            twoLevelCommentPageNum:0,           //获取二级评论页码参数
            hideTwoLevelComment:false,          //显示收起更多二级评论按钮
            curHideBtnId:'',                    //根据ID判断要显示收起按钮的评论
            getMoreIdChange:'',                 //判断点击查看更多的对应评论是否变化
            curCommentForId:'',                 //点击查看更多时储存返回二级评论的FOR_ID(父子级关系)
			loadingDone:false,                  //评论数据是否加载完成
			date:new Date(),                    //定义事件对象
			curTime:'',                         //每次进入页面获取实时的时间
			textareaFocus:false                 //判断评论输入框光标移入改变高度
        }
    },
    created(){
		//获取实时时间请求接口
		this.curTime=this.date.getFullYear()+'-'
		this.curTime=this.curTime+(this.date.getMonth()+1)+'-'
		this.curTime=this.curTime+(this.date.getDate())+' '
		this.curTime=this.curTime+(this.date.getHours())+':'
		this.curTime=this.curTime+(this.date.getMinutes())+':'
		this.curTime=this.curTime+(this.date.getSeconds())
        Axios.get('/comment/'+this.$route.query.id,{params:{page:this.oneLevelCommentPageNum,num:5,limittime:this.curTime}})
        .then(
            response=>{
                console.log(response)
                if(response.data.code==200&&response.data.status=="success"){
                    this.oneLevelCommentList=response.data.data.list
                    this.haveMoreOneLevelComment=response.data.data.many
                    this.loadingDone=true
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
        )
    },
    watch:{
        'getMoreIdChange':function(newval,val){
            if(val){
                this.hideMoreTwoLevelCommentAuto(val)
            }
        }
    },
    methods:{
		textBlur(){
			if(this.commentContent==""){
				this.textareaFocus=false
			}
		},
		changeCommentBoxHeight(){
			this.textareaFocus=true
		},
        //watch比点击事件后执行  页码有问题
        getMoreTwoLevelComment(e){
            this.getMoreIdChange=e.target.dataset.role
            if(this.curCommentForId!==""){
                //切换其他评论查看更多时页码归0
                if(Number(e.target.dataset.role)!==this.curCommentForId){
                    this.twoLevelCommentPageNum=0
                }
            }
            //点击查看更多时根据点击的评论ID获取到对应评论的数据
            let curCommentItem=this.oneLevelCommentList.filter((item,index)=>{
                return item.id==e.target.dataset.role
            })
            //根据many数据判断 如果还有更多二级评论 则点击查看更多时page页面++获取下一页数据
            if(curCommentItem[0].many!==0){
                this.twoLevelCommentPageNum++
                Axios.get('/comment/child/'+e.target.dataset.role,{params:{page:this.twoLevelCommentPageNum,num:3,limittime:this.curTime}})
                .then(
                    response=>{
                        console.log(response)
                        if(response.data.code==200&&response.data.status=="success"){
                            this.curCommentForId=response.data.data.list[0].for_id
                            //第一次点击查看更多时删除一级评论里默认附带的第一项二级评论
                            if(this.twoLevelCommentPageNum==1){
                                response.data.data.list.splice(0,1)
                            }
                            this.hideTwoLevelComment=false
                            //当返回数据更多二级评论为 0 隐藏查看更多按钮显示收起按钮
                            if(response.data.data.many==0){
                                this.twoLevelCommentPageNum=0
                                this.hideTwoLevelComment=true
                                this.curHideBtnId=e.target.dataset.role
                            }
                            //重新复制是否还存在更多二级评论
                            curCommentItem[0].many=response.data.data.many
                            //把新获取到的二级评论添加到对应的评论数组中
                            curCommentItem[0].child.push(...response.data.data.list)
                        }
                    }
                ).catch(
                    error=>{
                        console.log(error)
                    }
                )
            }
        },
        hideMoreTwoLevelComment(e){
            let curCommentItem=this.oneLevelCommentList.filter((item,index)=>{
                return item.id==e.target.dataset.role
            })
            curCommentItem[0].child=curCommentItem[0].child.splice(0,1)
            Axios.get('/comment/child/'+e.target.dataset.role,{params:{page:this.twoLevelCommentPageNum,num:2,limittime:this.curTime}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        //把二级评论请求页面还原到0
                        this.twoLevelCommentPageNum=0
                        //隐藏收起按钮
                        this.hideTwoLevelComment=false
                        //把还有更多评论判断条件还原为还有更多
                        //如果没有更多不会出现收起操作
                        curCommentItem[0].many=1
                    }
                }
            ).catch(
                error=>{
                    console.log(error)
                }
            )
            
        },
        //切换其他评论显示更多时自动收起上一条评论
        hideMoreTwoLevelCommentAuto(val){
            let curCommentItem=this.oneLevelCommentList.filter((item,index)=>{
                return item.id==val
            })
            curCommentItem[0].child=curCommentItem[0].child.splice(0,1)
            Axios.get('/comment/child/'+val,{params:{page:this.twoLevelCommentPageNum,num:2,limittime:this.curTime}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        curCommentItem[0].many=1
                    }
                }
            ).catch(
                error=>{
                    console.log(error)
                }
            )
            
        },
        //屏幕往上滑动时加载评论
        onCommentLoad(){
            if(this.haveMoreOneLevelComment==0){
                this.finished=true
                return false
            }else if(!this.haveMoreOneLevelComment==0){
                this.oneLevelCommentPageNum++
                Axios.get('/comment/'+this.$route.query.id,{params:{page:this.oneLevelCommentPageNum,num:5,limittime:this.curTime}})
                .then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.haveMoreOneLevelComment=response.data.data.many
                            this.oneLevelCommentList.push(...response.data.data.list)
                            this.loading=false
                        }
                    }
                ).catch(
                    error=>{
                        this.finished=true
                        //this.error=true;
                    }
                )
            }
        },
        //发表二级评论时点击一级评论获取对应id(for_id参数)
        getForId(e){
            this.forId=e.currentTarget.dataset.role
        },
        //添加一级评论
        addOneLevelComment(){
			//从评论页登录后返回评论页未Axios设置token否则不刷新登录状态
			if(GetCookie('token')){
				Axios.defaults.headers.common['Authorization']=GetCookie('token')
			}
            if(this.commentContent==""){
                this.$swal({
					text:'评论内容不能为空',
					showConfirmButton:false,
					width:'6rem',
					padding:'0.5rem',
					timer:1200,
					imageWidth:50,
					imageHeight:50,
					imageUrl:notifyIcon,
					timerProgressBar: true
				});
                return false
            }
            this.sendBtnDisabled=true
            this.commentSending=true
            this.$refs.sendBtn.innerHTML="发送中..."
            Axios.post('/comment',{article_id:this.$route.query.id,contents:this.commentContent})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.sendBtnDisabled=false
                        this.commentSending=false
                        this.$refs.sendBtn.innerHTML="发表"
                        this.commentContent=""
                        this.textareaFocus=false
                        this.$swal({
                            text:'发送成功 审核通过后会显示在评论区 请稍后',
                            showConfirmButton:false,
                            width:'6rem',
                            padding:'0.5rem',
                            timer:1100,
                            imageWidth:50,
                            imageHeight:50,
                            imageUrl:notifyIcon,
                            timerProgressBar: true
                        })
                    }
                }
            ).catch(
                error=>{
                    this.sendBtnDisabled=false
                    this.commentSending=false
                    this.$refs.sendBtn.innerHTML="发表"
                    if(error.response.data.code==422){
                        this.$swal({
                            text:'未登录或登录超时 请重新登录',
                            showConfirmButton:false,
                            width:'6rem',
                            padding:'0.5rem',
                            timer:800,
                            imageWidth:50,
                            imageHeight:50,
                            imageUrl:notifyIcon,
                            timerProgressBar: true
                        })
                        setTimeout(()=>{
                            location.href='/login'
                        },800)
                    }else{
                        this.$swal({
                            text:'网络错误请稍后重试',
                            showConfirmButton:false,
                            width:'6rem',
                            padding:'0.5rem',
                            timer:1000,
                            imageWidth:50,
                            imageHeight:50,
                            imageUrl:notifyIcon,
                            timerProgressBar: true
                        })
                    }
                }
            )
        }
    },
    components:{
        Loading
    }
}
</script>

<style scoped lang="scss">
    .all-comment{
        position:relative;
        padding:120px 45px 110px 45px;
        width:660px;
        .user-comment-item{
            overflow:hidden;
            margin-bottom:50px;
            .user-avatar{
                width:62px;
                height:62px;
                margin-right:16px;
                float:left;
                img{
                    width:100%;
                    height:100%;
                    border-radius:50%;
                }
            }
            .user-comment-detail{
                width:580px;
                float:left;
                .user-name{
                    height:21px;
                    font-size:22px;
                    color:#222;
                    margin-bottom:24px;
                }
                .comment-cont{
                    font-size:22px;
                    color:#999;
                    line-height:36px;
                }
            }
            .user-comment-detail:active{
                background:#F5F5F5;
            }
            .second-level-comment{
                width:582px;
                float:right;
                margin-top:22px;
                border-radius:10px;
                li{
                    padding:38px 22px;
                    overflow:hidden;
                    margin-bottom:18px;
                    background:#F8F6F7;
                }
                .user-comment-detail{
                    width:420px;
                }
                .show-all-second-level-comment,.hide-all-second-level-comment{
                    font-size:20px;
                    color:#999;
                    margin-bottom:26px;
                    .van-icon-arrow-down,.van-icon-arrow-up{
                        margin-left:10px;
                        transform:translateY(2px);
                    }
                }
            }
        }
        .add-comment-box{
            position:fixed;
            bottom:0;
            left:0;
            width:750px;
            height:110px;
            line-height:110px;
            background:#fffeff;
            box-shadow:0px -1px 4px #F5F5F5;
            textarea{
				position:absolute;
				left:18px;
				top:50%;
				transform:translateY(-33px);
                width:516px;
				height:30px;
				padding:16px 16px 16px 16px;
				line-height:24px;
                border:none;
                background:#F8F6F7;
                color:#999;
                border-radius:35px;
                margin-right:12px;
                font-size:24px;
				resize:none;
            }
            textarea::placeholder{
                color: #ccc !important;
				line-height:30px;
            }
            button{
				position:absolute;
				right:18px;
				top:50%;
				transform:translateY(-33px);
                display:inline-block;
                background:#bf0000;
                width:152px;
                height:66px;
                line-height:64px;
                border-radius:35px;
                text-align:center;
                color:#fff;
                font-size:24px;
                border:none;
            }
            button:active{
                background:#DD8080;
            }
            .sending{
                background:#DD8080;
            }
        }
		.add-comment-box-focus{
			height:200px !important;
		}
		.textarea-focus{
			height:120px !important;
			transform:translateY(-78px) !important;
		}
		.btn-in-textarea-focus{
			height:152px !important;
			transform:translateY(-78px) !important;
		}
    }
</style>